(() => {
  let library;
  async function render(file, config, signal) {
    if (!config?.library || !config?.worker) throw new Error('PDF-voorbeeld niet beschikbaar.');
    library ||= import(config.library).catch(error => { library = null; throw error; });
    const pdfjs = await library;
    if (signal.aborted) throw new DOMException('Geannuleerd', 'AbortError');
    pdfjs.GlobalWorkerOptions.workerSrc = config.worker;
    const bytes = new Uint8Array(await file.arrayBuffer());
    if (signal.aborted) throw new DOMException('Geannuleerd', 'AbortError');
    const base = new URL('.', config.library).href;
    const task = pdfjs.getDocument({data:bytes, isEvalSupported:false, useWasm:false, useWorkerFetch:true,
      standardFontDataUrl:base, cMapUrl:base, cMapPacked:true});
    // Password-protected files should fail clearly rather than wait for a prompt.
    let rejectPassword;
    const passwordRequired = new Promise((_,reject) => { rejectPassword = reject; });
    task.onPassword = () => rejectPassword(new Error('Gebruik een PDF zonder wachtwoord.'));
    const abort = () => { task.destroy().catch(() => {}); };
    signal.addEventListener('abort', abort, {once:true});
    try {
      const pdf = await Promise.race([task.promise,passwordRequired]);
      if (signal.aborted) throw new DOMException('Geannuleerd', 'AbortError');
      const page = await pdf.getPage(1), natural = page.getViewport({scale:1});
      const longest = Math.max(natural.width, natural.height);
      if (!Number.isFinite(longest) || longest <= 0) throw new Error('Ongeldige PDF-pagina.');
      const viewport = page.getViewport({scale:Math.min(4,2048/longest)});
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1,Math.ceil(viewport.width));
      canvas.height = Math.max(1,Math.ceil(viewport.height));
      const context = canvas.getContext('2d',{willReadFrequently:true});
      await page.render({canvasContext:context, viewport, background:'rgba(0,0,0,0)'}).promise;
      if (signal.aborted) throw new DOMException('Geannuleerd', 'AbortError');
      // Remove page margins from the preview, preserving the pixels in the artwork.
      // Prefer non-white artwork; fall back to alpha bounds for white-only designs.
      const pixels = context.getImageData(0,0,canvas.width,canvas.height).data;
      function bounds(nonWhite) {
        let left=canvas.width,top=canvas.height,right=-1,bottom=-1;
        for(let y=0;y<canvas.height;y++)for(let x=0;x<canvas.width;x++){
          const i=(y*canvas.width+x)*4;
          if(pixels[i+3]>8 && (!nonWhite || Math.min(pixels[i],pixels[i+1],pixels[i+2])<245)){
            left=Math.min(left,x);top=Math.min(top,y);right=Math.max(right,x);bottom=Math.max(bottom,y);
          }
        }
        return right>=left?{left,top,right,bottom}:null;
      }
      const box=bounds(true)||bounds(false);
      if(!box)throw new Error('De eerste PDF-pagina is leeg.');
      const cropped=document.createElement('canvas');
      const left=Math.max(0,box.left-2),top=Math.max(0,box.top-2);
      cropped.width=Math.min(canvas.width-1,box.right+2)-left+1;
      cropped.height=Math.min(canvas.height-1,box.bottom+2)-top+1;
      cropped.getContext('2d').drawImage(canvas,left,top,cropped.width,cropped.height,0,0,cropped.width,cropped.height);
      return {src:cropped.toDataURL('image/png'),pages:pdf.numPages};
    } finally {
      signal.removeEventListener('abort',abort);
      await task.destroy().catch(() => {});
    }
  }
  window.KBPdfPreview = {render};
})();
